import { render, staticRenderFns } from "./MainLedgerUpload.vue?vue&type=template&id=3ca0584b"
import script from "./MainLedgerUpload.vue?vue&type=script&lang=js"
export * from "./MainLedgerUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports